// https://github.com/michaelwittig/node-i18n-iso-countries/tree/master/langs
// https://vee-validate.logaretm.com/v3/guide/localization.html#using-other-i18n-libraries
import { de_mad } from "./lang/de";
import { en_mad } from "./lang/en";
import { fr_mad } from "./lang/fr";
export var messages = {
    de: de_mad,
    en: en_mad,
    fr: fr_mad,
};
